import './spinner.scss';
import React from 'react';

const Spinner = props => (
    <div data-testid="lkspinner" className={`${props.fullpage ? 'page-loading-overlay' : 'lkspinner-container'}`} style={props.style}><div className="lkspinner"></div></div>
);

export default Spinner;
